export class regex {


    static IsPossibleLicenseKey(value: string): boolean {

        if (value.length < 6) {
            return true;
        } else if (value.length > 17) {
            return false;
        }

        if (value.length == 6) {

            if (value.substr(value.length - 1) == '-') {
                return true;
            } else {
                return false;
            }

        }


        if (value.length > 6 && value.length < 12) {
            let regPartialFirstSectionLicenseKey: string = '^[A-Za-z0-9]{5}(-)';
            let isPossibleCdKey = new RegExp(regPartialFirstSectionLicenseKey).test(value);
            return isPossibleCdKey;
        }

        if (value.length == 12 && value.substr(value.length - 1) == '-') {
            return true;
        }

        if (value.length > 12 && value.length < 17) {

            let regPartialLicenseKey: string = '^[A-Za-z0-9]{5}(-)[A-Za-z0-9]{5}(-)';
            let isPossibleCdKey = new RegExp(regPartialLicenseKey).test(value);
            return isPossibleCdKey;


        }

        if (value.length == 17) {

            let regFullLicenseKey: string = '^[A-Za-z0-9]{5}(-)[A-Za-z0-9]{5}(-)[A-Za-z0-9]{5}';
            let isPossibleCdKey = new RegExp(regFullLicenseKey).test(value);
            return isPossibleCdKey;
        }


        return false;

    }

}
